import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { DefaultService as api, PostAddCompanionRequest } from 'src/sdk_checkin';
import { CheckinBaseClass } from '../../components';
import {
  CheckinPassengerAdditionResultState,
  CheckinPassengerAdditionResultStore,
  resetCheckinPassengerAdditionResult,
  selectCheckinPassengerAdditionResultState,
  setCheckinPassengerAdditionResultFromApi,
} from '../../store/checkin-passenger-addition-result';

@Injectable()
export class CheckinPassengerAdditionResultStoreService extends CheckinBaseClass {
  /** 同行者追加APIのレスポンス */
  private _checkinPassengerAdditionResult$ = this._checkinPassengerAdditionResultStore.pipe(
    select(selectCheckinPassengerAdditionResultState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  /**
   * エラーが発生していない同行者追加APIのレスポンス通知
   */
  get success$(): Observable<CheckinPassengerAdditionResultState> {
    return this._checkinPassengerAdditionResult$.pipe(filter((state) => state.isFailure === false));
  }

  /**
   * エラーが発生している同行者追加APIのレスポンス通知
   */
  get failure$(): Observable<CheckinPassengerAdditionResultState> {
    return this._checkinPassengerAdditionResult$.pipe(filter((state) => state.isFailure === true));
  }

  constructor(
    private _checkinPassengerAdditionResultStore: Store<CheckinPassengerAdditionResultStore>,
    private api: api
  ) {
    super();
  }

  /**
   * 共通事後処理
   */
  override destroy(): void {
    this._checkinPassengerAdditionResultStore.dispatch(resetCheckinPassengerAdditionResult());
  }

  /**
   * 同行者追加APIを呼び出す
   * @param parameter 同行者リスト
   */
  request(parameter: PostAddCompanionRequest): void {
    const call = this.api.addCompanionPost(parameter);
    this._checkinPassengerAdditionResultStore.dispatch(setCheckinPassengerAdditionResultFromApi({ call }));
  }
}
